import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { createVendor, editVendor, fetchVendorDetail } from '../../actions/vendors_actions';
import { setDefaultOfForm, changeFieldArrayOfForm } from '../../actions/purchaseOrders_actions';

import VendorDetailForm from '../../components/Vendors/vendorDetailForm';

import { ROOT_URL, ROOT_API_URL, isSV } from '../../actions/root_url';

const validate = values => {
    const errors = {}
    if (!values.Name) {
        errors.Name = 'Required';
    }
    if (!values.VendorNum && !isSV) {
        errors.VendorNum = 'Required';
    }
    if (!values.Description) {
        errors.Description = 'Required';
    }
    return errors;
};

const vendorDetailForm = reduxForm({
  form: 'vendorDetailForm',
})(VendorDetailForm);

const selector = formValueSelector('vendorDetailForm');

function mapStateToProps(state) {
  const paymentTerm_id = selector(state, 'PaymentTerm_id');
  const isActive = selector(state, 'IsActive');
  const overseas = selector(state, 'overseas');
  const billing = selector(state, 'Billing');
  const mailing = selector(state, 'Mailing');
  const shipping = selector(state, 'Shipping');
  const Name = selector(state, 'Name');
  
  let companies = state.header.companies;
  let companySelection = companies.map(({ Name, id }) => ({
    label: Name,
    value: id,
  }));
  return {
    paymentTerm_id,
    isActive,
    overseas,
    billing,
    mailing,
    Name,
    shipping,
    companySelection,
    currentVendor: state.vendors.currentVendor,
    currentVendorDetail: state.vendors.currentVendorDetail,
    detailIsLoading: state.vendors.detailIsLoading,
    detailError: state.vendors.detailError,
    initialValues: state.vendors.currentVendorDetail,
    paymentTerms: state.paymentTerms.all,
    paymentTermsIsLoading: state.paymentTerms.isLoading,
    paymentTermsError: state.paymentTerms.error,
    isCreating: state.vendors.isCreating,
    createError: state.vendors.createError,
    created: state.vendors.created,
    isEditing: state.vendors.isEditing,
    editError: state.vendors.editError,
    edited: state.vendors.edited,
    userPermissions: state.auth.userPermissions,
    selectedCompany: state.header.selectedCompany,
    companies: state.header.companies,
  };
}

export default connect(mapStateToProps, {
  fetchPaymentTerms, createVendor, editVendor, fetchVendorDetail, setDefaultOfForm, changeFieldArrayOfForm,
})(vendorDetailForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Vendors/vendorDetailForm.jsx